// Shared report titles and anchors for budget and map navigation.
export const BOE_REPORTS = [
  {"title": "BUDGET SUMMARY", "id": "boe-budget-summary-heading"},
  {"title": "STAFF", "id": "boe-staff-heading"},
  {"title": "STUDENTS", "id": "boe-students-heading"},
  {"title": "PPE", "id": "boe-ppe-heading"},
  {"title": "0200 - ART", "id": "boe-0200-art-heading"},
  {"title": "0300 - BASIC EDUCATION", "id": "boe-0300-basic-education-heading"},
  {"title": "0400 - ENGLISH 7-12 / READING AND LANGUAGE ARTS", "id": "boe-0400-english-7-12-reading-and-language-arts-heading"},
  {"title": "0500 - MATHEMATICS", "id": "boe-0500-mathematics-heading"},
  {"title": "0600 - SCIENCE", "id": "boe-0600-science-heading"},
  {"title": "0700 - HISTORY & SOCIAL SCIENCES", "id": "boe-0700-history-social-sciences-heading"},
  {"title": "0900 - CAREER & TECHNICAL EDUCATION", "id": "boe-0900-career-technical-education-heading"},
  {"title": "1000 - COMMUNITY SERVICES", "id": "boe-1000-community-services-heading"},
  {"title": "1100 - P.A.C.E.", "id": "boe-1100-p-a-c-e--heading"},
  {"title": "1300 - FOREIGN LANGUAGE & ELL", "id": "boe-1300-foreign-language-ell-heading"},
  {"title": "1400 - SCHOOL COUNSELING", "id": "boe-1400-school-counseling-heading"},
  {"title": "1500 - HEALTH & PHYSICAL EDUCATION", "id": "boe-1500-health-physical-education-heading"},
  {"title": "1600 - HEALTH SERVICES", "id": "boe-1600-health-services-heading"},
  {"title": "1900 - LIBRARY MEDIA", "id": "boe-1900-library-media-heading"},
  {"title": "2000 - MUSIC", "id": "boe-2000-music-heading"},
  {"title": "2100 - OPERATIONS & MAINTENANCE", "id": "boe-2100-operations-maintenance-heading"},
  {"title": "2200 - UTILITIES", "id": "boe-2200-utilities-heading"},
  {"title": "2300 - PROGRAM & STAFF DEVELOPMENT", "id": "boe-2300-program-staff-development-heading"},
  {"title": "2400 - TRANSPORTATION", "id": "boe-2400-transportation-heading"},
  {"title": "2700 - SPECIAL EDUCATION", "id": "boe-2700-special-education-heading"},
  {"title": "2800 - ATHLETICS & CLUBS", "id": "boe-2800-athletics-clubs-heading"},
  {"title": "3000 - AGRISCIENCE & TECHNOLOGY 9-12", "id": "boe-3000-agriscience-technology-9-12-heading"},
  {"title": "3100 - ELEMENTRY OPERATIONS K-6", "id": "boe-3100-elementry-operations-k-6-heading"},
  {"title": "3200 - SECONDARY OPERATIONS 7-12", "id": "boe-3200-secondary-operations-7-12-heading"},
  {"title": "3300 - SYSTEMWIDE SUPPORT SERVICES", "id": "boe-3300-systemwide-support-services-heading"},
  {"title": "3400 - FRINGE BENEFITS & SUBSTITUTES", "id": "boe-3400-fringe-benefits-substitutes-heading"},
  {"title": "3600 - TECHNOLOGY SUPPORT SERVICES", "id": "boe-3600-technology-support-services-heading"},
];
